(function () {
  'use strict';

  var configNode = document.getElementById('akwaya-optional-widgets');
  if (!configNode) return;
  var config;
  try { config = JSON.parse(configNode.textContent); } catch (error) { return; }
  var desktop = window.matchMedia('(min-width: 769px)');
  var formsTask;

  function addScript(id, source, module) {
    return new Promise(function (resolve, reject) {
      var script = document.getElementById(id);
      if (script && script.dataset.loaded === 'true') { resolve(); return; }
      if (!script) {
        script = document.createElement('script');
        script.id = id;
        script.src = source;
        script.async = true;
        if (module) { script.type = 'module'; script.crossOrigin = 'anonymous'; }
      }
      script.addEventListener('load', function () {
        script.dataset.loaded = 'true';
        resolve();
      }, { once: true });
      script.addEventListener('error', function () {
        script.remove();
        reject(new Error('Optional component could not load'));
      }, { once: true });
      if (!script.isConnected) document.head.appendChild(script);
    });
  }

  window.akwayaLoadReviewForm = function () {
    if (!config.forms) return Promise.resolve();
    if (!formsTask) {
      window.ShopifyForms = Object.assign({}, window.ShopifyForms, { currentPageType: config.pageType });
      formsTask = addScript('akwaya-native-forms-loader', config.formsSource, false).catch(function (error) {
        formsTask = null;
        throw error;
      });
    }
    return formsTask;
  };

  function loadDesktopWidgets() {
    if (!desktop.matches) return;
    window.akwayaLoadReviewForm().catch(function () {});
  }

  function afterLoad() {
    if (window.requestIdleCallback) window.requestIdleCallback(loadDesktopWidgets, { timeout: 1500 });
    else window.setTimeout(loadDesktopWidgets, 0);
  }

  if (document.readyState === 'complete') afterLoad();
  else window.addEventListener('load', afterLoad, { once: true });
  desktop.addEventListener('change', loadDesktopWidgets);
  document.addEventListener('pointerdown', loadDesktopWidgets, { once: true, passive: true });
  document.addEventListener('keydown', loadDesktopWidgets, { once: true });
})();

